<template>
    <div class="global-coin-dialogs">
        <el-dialog :visible.sync="showBuyCoinsDialog" :width="buyCoinsDialogWidth" center class="buy-coins-dialog">
            <div slot="title" class="buy-coins-dialog-title">
                <i class="el-icon-coin"></i>
                <span>购买金币</span>
            </div>
            <div class="buy-coins-body">
                <div class="buy-coins-field">
                    <label class="buy-coins-label">购买数量</label>
                    <el-input-number
                        v-model="buyCoinsCount"
                        :min="10"
                        :max="9999"
                        controls-position="right"
                        class="buy-coins-input"
                    ></el-input-number>
                </div>
                <div class="buy-coins-summary">
                    <div class="buy-coins-row">
                        <span class="buy-coins-desc">单价</span>
                        <span class="buy-coins-price">{{ pricePerCoin }} 元/金币</span>
                    </div>
                    <div class="buy-coins-row total">
                        <span class="buy-coins-desc">应付金额</span>
                        <span class="buy-coins-amount">{{ buyPaymentAmount }} 元</span>
                    </div>
                    <div class="buy-coins-row">
                        <span class="buy-coins-desc">支付方式</span>
                        <el-radio-group v-model="buyCoinsPayType" size="small">
                            <el-radio-button label="alipay">支付宝</el-radio-button>
                            <el-radio-button label="wechat">微信支付</el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
                <div class="buy-coins-footer">
                    <el-button type="primary" icon="el-icon-wallet" @click="confirmBuyCoins" class="buy-coins-btn">
                        确认支付
                    </el-button>
                    <el-button @click="showBuyCoinsDialog = false">取消</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="showEarnCodeDialog"
            :width="showwidth"
            center
            class="earn-coin-dialog"
            @close="handleEarnDialogClosed"
        >
            <div slot="title" class="earn-coin-dialog-title">
                <i class="el-icon-present"></i>
                <span>赚金币</span>
            </div>
            <div class="earn-coin-body">
                <div class="earn-coin-tip">
                    <i class="el-icon-info-outline"></i>
                    <span>
                        {{ earnDialogTipText }}
                    </span>
                </div>

                <div v-if="earnDialogUsesMiniProgram && earnSessionLoading" class="earn-state-panel">
                    <i class="el-icon-loading"></i>
                    <span>正在生成小程序码...</span>
                </div>

                <div v-else-if="earnDialogUsesMiniProgram && earnSessionError" class="earn-state-panel earn-state-panel--error">
                    <i class="el-icon-warning-outline"></i>
                    <span>{{ earnSessionError }}</span>
                </div>

                <div v-else-if="earnDialogQrImageSrc" class="earn-coin-qr-wrap">
                    <img class="earn-coin-qr" :src="earnDialogQrImageSrc" :alt="earnDialogQrAlt">
                </div>

                <div v-if="earnDialogUsesLegacy" class="legacy-earn-code-wrap">
                    <label class="legacy-earn-code-label">{{ legacyCodeLabelText }}</label>
                    <el-input
                        v-model="legacyEarnCode"
                        maxlength="6"
                        show-word-limit
                        :placeholder="legacyCodePlaceholder"
                        clearable
                    ></el-input>
                </div>

                <div class="earn-status-box" :class="earnStatusClass">
                    <div class="earn-status-title">{{ earnStatusTitle }}</div>
                    <div class="earn-status-desc">{{ earnStatusDesc }}</div>
                </div>

                <div class="earn-coin-footer">
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        :loading="earnSessionLoading"
                        v-if="earnDialogUsesMiniProgram"
                        @click="createEarnSession"
                    >
                        {{ earnQrImageSrc ? '重新生成' : '生成小程序码' }}
                    </el-button>
                    <el-button
                        v-else-if="earnDialogUsesLegacy"
                        type="primary"
                        icon="el-icon-check"
                        :loading="legacyEarnSubmitting"
                        @click="submitLegacyEarnCode"
                    >
                        {{ legacySubmitButtonText }}
                    </el-button>
                    <el-button
                        v-if="earnDialogUsesMiniProgram"
                        plain
                        icon="el-icon-refresh-right"
                        :disabled="!earnSessionId || earnSessionLoading || earnSessionStatus === 'completed'"
                        @click="pollEarnSessionStatusOnce(true)"
                    >
                        刷新状态
                    </el-button>
                    <el-button @click="showEarnCodeDialog = false">关闭</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog
            center
            :before-close="function(){}"
            :show-close="false"
            :destroy-on-close="true"
            :visible.sync="dialogTableVisible"
            :width="payQrDialogWidth"
            class="pay-qr-dialog"
        >
            <pay :img="qrimg" :money="money" :paytype="currentPayType"></pay>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="paystatus" plain>已完成支付</el-button>
                <el-button type="info" @click="paystatus" plain>支付遇到问题</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import pay from './pay.vue'

export default {
    name: 'GlobalCoinDialogs',
    components: { pay },
    data() {
        return {
            showBuyCoinsDialog: false,
            showEarnCodeDialog: false,
            buyCoinsCount: 10,
            pricePerCoin: 0.1,
            dialogTableVisible: false,
            qrimg: '',
            money: 0.1,
            paymentOrderNo: '',
            isBuyCoinsPayment: false,
            showwidth: '80vw',
            buyCoinsDialogWidth: '92vw',
            payQrDialogWidth: '92vw',
            buyCoinsPayType: 'wechat',
            currentPayType: 'wepay',
            earnSessionId: '',
            earnSessionLoading: false,
            earnSessionError: '',
            earnQrImageSrc: '',
            earnSessionStatus: '',
            earnSessionExpireAt: '',
            earnPollTimer: null,
            earnRewardAmount: 1,
            earnCompletedHandled: false,
            legacyEarnCode: '',
            legacyEarnSubmitting: false
        }
    },
    computed: {
        buyPaymentAmount() {
            const n = Number(this.buyCoinsCount)
            if (isNaN(n) || n < 1) return '0.00'
            return (n * this.pricePerCoin).toFixed(2)
        },
        legacyCoinFeatureEnabled() {
            return this.$store.state.legacyCoinFeatureEnabled !== false
        },
        miniProgramCoinFeatureEnabled() {
            return !!this.$store.state.miniProgramCoinFeatureEnabled
        },
        earnDialogUsesMiniProgram() {
            return this.miniProgramCoinFeatureEnabled
        },
        earnDialogUsesLegacy() {
            return !this.earnDialogUsesMiniProgram && this.legacyCoinFeatureEnabled
        },
        earnDialogTipText() {
            if (this.earnDialogUsesLegacy) {
                return '\u8bf7\u7528\u624b\u673a\u5fae\u4fe1\u626b\u7801\u770b\u89c6\u9891\u83b7\u53d6\u9a8c\u8bc1\u7801\uff0c\u8f93\u5165\u9a8c\u8bc1\u7801\u540e\u5373\u53ef\u9886\u53d6 1 \u91d1\u5e01\u3002'
            }
            return '\u8bf7\u7528\u624b\u673a\u5fae\u4fe1\u626b\u63cf\u4e0b\u65b9\u5c0f\u7a0b\u5e8f\u7801\uff0c\u5728\u5c0f\u7a0b\u5e8f\u91cc\u770b\u5b8c\u5e7f\u544a\u540e\uff0c\u91d1\u5e01\u4f1a\u81ea\u52a8\u53d1\u653e\u5230\u5f53\u524d\u7f51\u7ad9\u8d26\u53f7\uff0c\u65e0\u9700\u518d\u8f93\u5165\u9a8c\u8bc1\u7801\u3002'
        },
        earnDialogQrImageSrc() {
            if (this.earnDialogUsesLegacy) return require('@/assets/code.png')
            return this.earnQrImageSrc
        },
        earnDialogQrAlt() {
            return '\u626b\u7801\u8d5a\u91d1\u5e01'
        },
        legacyCodeLabelText() {
            return '\u9a8c\u8bc1\u7801'
        },
        legacyCodePlaceholder() {
            return '\u8bf7\u8f93\u5165 6 \u4f4d\u9a8c\u8bc1\u7801'
        },
        legacySubmitButtonText() {
            return '\u786e\u8ba4\u9886\u53d6'
        },
        earnStatusTitle() {
            if (this.earnDialogUsesLegacy) {
                return this.legacyEarnSubmitting ? '\u6b63\u5728\u9a8c\u8bc1\u9a8c\u8bc1\u7801' : '\u626b\u7801\u83b7\u53d6\u9a8c\u8bc1\u7801'
            }
            if (this.earnSessionLoading) return '\u6b63\u5728\u751f\u6210\u5c0f\u7a0b\u5e8f\u7801'
            if (this.earnSessionError) return '\u751f\u6210\u5931\u8d25'
            if (this.earnSessionStatus === 'completed') return '\u5956\u52b1\u5df2\u5230\u8d26'
            if (this.earnSessionStatus === 'expired') return '\u4f1a\u8bdd\u5df2\u8fc7\u671f'
            if (this.earnSessionId) return '\u7b49\u5f85\u5c0f\u7a0b\u5e8f\u5b8c\u6210\u5e7f\u544a'
            return '\u7b49\u5f85\u751f\u6210'
        },
        earnStatusDesc() {
            if (this.earnDialogUsesLegacy) {
                return this.legacyEarnSubmitting
                    ? '\u6b63\u5728\u6821\u9a8c\u60a8\u8f93\u5165\u7684\u9a8c\u8bc1\u7801\uff0c\u8bf7\u7a0d\u5019\u3002'
                    : '\u4f7f\u7528\u624b\u673a\u5fae\u4fe1\u626b\u7801\u770b\u89c6\u9891\uff0c\u8f93\u5165 6 \u4f4d\u9a8c\u8bc1\u7801\u540e\u5373\u53ef\u9886\u53d6 1 \u91d1\u5e01\u3002'
            }
            if (this.earnSessionLoading) return '\u8bf7\u7a0d\u5019\uff0c\u7f51\u7ad9\u6b63\u5728\u521b\u5efa\u672c\u6b21\u8d5a\u91d1\u5e01\u4f1a\u8bdd\u3002'
            if (this.earnSessionError) return '\u53ef\u70b9\u51fb\u201c\u91cd\u65b0\u751f\u6210\u201d\u518d\u6b21\u83b7\u53d6\u5c0f\u7a0b\u5e8f\u7801\u3002'
            if (this.earnSessionStatus === 'completed') {
                return `\u5df2\u81ea\u52a8\u53d1\u653e ${this.earnRewardAmount} \u91d1\u5e01\u5230\u5f53\u524d\u7f51\u7ad9\u8d26\u53f7\u3002`
            }
            if (this.earnSessionStatus === 'expired') {
                return '\u672c\u6b21\u4e8c\u7ef4\u7801\u5df2\u5931\u6548\uff0c\u8bf7\u91cd\u65b0\u751f\u6210\u540e\u518d\u626b\u7801\u3002'
            }
            if (this.earnSessionId) {
                return '\u626b\u7801\u8fdb\u5165\u5c0f\u7a0b\u5e8f\u5e76\u770b\u5b8c\u5e7f\u544a\u540e\uff0c\u7f51\u7ad9\u4f1a\u81ea\u52a8\u5237\u65b0\u91d1\u5e01\u3002'
            }
            return '\u70b9\u51fb\u4e0b\u65b9\u6309\u94ae\u751f\u6210\u672c\u6b21\u4e13\u5c5e\u5c0f\u7a0b\u5e8f\u7801\u3002'
        },
        earnStatusClass() {
            if (this.earnDialogUsesLegacy) return {}
            return {
                'earn-status-box--success': this.earnSessionStatus === 'completed',
                'earn-status-box--error': this.earnSessionStatus === 'expired' || !!this.earnSessionError
            }
        }
    },
    watch: {
        '$store.state.openPayDialog'(open) {
            if (open) {
                this.$store.commit('SetOpenPayDialog', false)
                this.$nextTick(() => {
                    this.showBuyCoinsDialog = true
                })
            }
        },
        '$store.state.openEarnCoinDialog'(open) {
            if (open) {
                this.$store.commit('SetOpenEarnCoinDialog', false)
                this.$nextTick(() => {
                    if (this.earnDialogUsesMiniProgram) {
                        this.resetLegacyEarnState()
                        this.showEarnCodeDialog = true
                        this.createEarnSession()
                        return
                    }
                    if (this.earnDialogUsesLegacy) {
                        this.resetEarnSessionState()
                        this.resetLegacyEarnState()
                        this.showEarnCodeDialog = true
                        return
                    }
                    this.$message({ message: '\u5f53\u524d\u672a\u5f00\u542f\u8d5a\u91d1\u5e01\u529f\u80fd', type: 'warning' })
                })
            }
        }
    },
    created() {
        if (typeof innerWidth !== 'undefined' && innerWidth > 768) {
            this.showwidth = '400px'
            this.buyCoinsDialogWidth = '420px'
            this.payQrDialogWidth = '680px'
        }
    },
    mounted() {
        this._resizeHandler = () => {
            if (window.innerWidth > 768) {
                this.showwidth = '400px'
                this.buyCoinsDialogWidth = '420px'
                this.payQrDialogWidth = '680px'
            } else {
                this.showwidth = '80vw'
                this.buyCoinsDialogWidth = '92vw'
                this.payQrDialogWidth = '92vw'
            }
        }
        window.addEventListener('resize', this._resizeHandler)
    },
    beforeDestroy() {
        if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler)
        this.clearEarnSessionPoll()
    },
    methods: {
        resetEarnSessionState() {
            this.clearEarnSessionPoll()
            this.earnSessionId = ''
            this.earnSessionLoading = false
            this.earnSessionError = ''
            this.earnQrImageSrc = ''
            this.earnSessionStatus = ''
            this.earnSessionExpireAt = ''
            this.earnRewardAmount = 1
            this.earnCompletedHandled = false
        },
        resetLegacyEarnState() {
            this.legacyEarnCode = ''
            this.legacyEarnSubmitting = false
        },
        handleEarnDialogClosed() {
            this.resetEarnSessionState()
            this.resetLegacyEarnState()
        },
        clearEarnSessionPoll() {
            if (this.earnPollTimer) {
                clearInterval(this.earnPollTimer)
                this.earnPollTimer = null
            }
        },
        startEarnSessionPoll() {
            this.clearEarnSessionPoll()
            this.pollEarnSessionStatusOnce(false)
            this.earnPollTimer = setInterval(() => this.pollEarnSessionStatusOnce(false), 2000)
        },
        submitLegacyEarnCode() {
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) {
                this.$message({ message: '\u8bf7\u5148\u767b\u5f55\u540e\u518d\u8d5a\u91d1\u5e01', type: 'warning' })
                this.showEarnCodeDialog = false
                return
            }
            const code = String(this.legacyEarnCode || '').trim()
            if (!code) {
                this.$message({ message: '\u8bf7\u8f93\u5165\u60a8\u83b7\u53d6\u5230\u7684\u9a8c\u8bc1\u7801', type: 'warning' })
                return
            }
            this.legacyEarnSubmitting = true
            this.$axios
                .post('/getcode', { code, type: '\u8d5a\u91d1\u5e01', token })
                .then((res) => {
                    const data = res.data
                    if (data === 'OK') {
                        const user = this.$store.state.user
                        if (user && user.coins != null) {
                            this.$store.commit('SetUserCoins', (Number(user.coins) || 0) + 1)
                        }
                        this.refreshUserCoinsFromServer()
                        this.$message({ message: '\u9a8c\u8bc1\u6210\u529f\uff0c\u5df2\u589e\u52a0 1 \u91d1\u5e01', type: 'success' })
                        this.showEarnCodeDialog = false
                        return
                    }
                    if (data === 'Wrong') {
                        this.$message({ message: '\u9a8c\u8bc1\u7801\u9519\u8bef', type: 'warning' })
                        return
                    }
                    if (data === 'Used') {
                        this.$message({ message: '\u8be5\u9a8c\u8bc1\u7801\u5df2\u7ecf\u88ab\u4f7f\u7528\u8fc7\u4e86', type: 'warning' })
                        return
                    }
                    this.$message({ message: '\u9a8c\u8bc1\u7801\u6821\u9a8c\u5931\u8d25\uff0c\u8bf7\u7a0d\u540e\u91cd\u8bd5', type: 'warning' })
                })
                .catch((err) => {
                    const msg =
                        (err.response && err.response.data && err.response.data.message) ||
                        err.message ||
                        '\u9a8c\u8bc1\u7801\u6821\u9a8c\u5931\u8d25\uff0c\u8bf7\u7a0d\u540e\u91cd\u8bd5'
                    this.$message({ message: msg, type: 'warning' })
                })
                .finally(() => {
                    this.legacyEarnSubmitting = false
                })
        },
        createEarnSession() {
            if (!this.earnDialogUsesMiniProgram) {
                this.$message({ message: '\u5f53\u524d\u672a\u5f00\u542f\u5c0f\u7a0b\u5e8f\u8d5a\u91d1\u5e01\u529f\u80fd', type: 'warning' })
                this.showEarnCodeDialog = false
                return
            }
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) {
                this.$message({ message: '请先登录后再赚金币', type: 'warning' })
                this.showEarnCodeDialog = false
                return
            }
            this.resetEarnSessionState()
            this.earnSessionLoading = true
            this.$axios
                .post('/earn/video/session/create', { token })
                .then((res) => {
                    const data = res.data || {}
                    if (!data.success || !data.sessionId || !data.imageBase64) {
                        throw new Error(data.message || '创建赚金币会话失败')
                    }
                    this.earnSessionId = data.sessionId
                    this.earnRewardAmount = Number(data.rewardAmount) || 1
                    this.earnSessionExpireAt = data.expireAt || ''
                    this.earnQrImageSrc =
                        'data:' + (data.mimeType || 'image/png') + ';base64,' + data.imageBase64
                    this.earnSessionStatus = 'pending'
                    this.startEarnSessionPoll()
                })
                .catch((err) => {
                    this.earnSessionError =
                        (err.response && err.response.data && err.response.data.message) ||
                        err.message ||
                        '创建赚金币会话失败'
                })
                .finally(() => {
                    this.earnSessionLoading = false
                })
        },
        pollEarnSessionStatusOnce(showPendingMessage) {
            if (!this.earnSessionId) return
            this.$axios
                .get('/earn/video/session/status', { params: { sessionId: this.earnSessionId } })
                .then((res) => {
                    const data = res.data || {}
                    if (!data.success) return
                    this.earnRewardAmount = Number(data.rewardAmount) || this.earnRewardAmount || 1
                    this.earnSessionExpireAt = data.expireAt || this.earnSessionExpireAt
                    this.earnSessionStatus = data.status || 'pending'
                    if (this.earnSessionStatus === 'completed') {
                        this.handleEarnCompleted()
                        return
                    }
                    if (this.earnSessionStatus === 'expired') {
                        this.clearEarnSessionPoll()
                        return
                    }
                    if (showPendingMessage) {
                        this.$message({
                            message: '网站仍在等待小程序完成广告，您看完后这里会自动到账。',
                            type: 'info'
                        })
                    }
                })
                .catch((err) => {
                    if (showPendingMessage) {
                        const msg =
                            (err.response && err.response.data && err.response.data.message) ||
                            err.message ||
                            '刷新状态失败'
                        this.$message({ message: msg, type: 'warning' })
                    }
                })
        },
        handleEarnCompleted() {
            this.clearEarnSessionPoll()
            if (this.earnCompletedHandled) return
            this.earnCompletedHandled = true
            this.refreshUserCoinsFromServer()
            this.$message({
                message: `看广告奖励已到账，已增加 ${this.earnRewardAmount} 金币`,
                type: 'success'
            })
            this.showEarnCodeDialog = false
        },
        doPayment(money, subject, payType) {
            const method = payType === 'wepay' ? 'wechat' : 'alipay'
            const data = { money, subject, payType: method }
            if (subject === '购买金币') {
                const token = this.$store.state.user && this.$store.state.user.token
                if (token) data.token = token
                data.coinAmount = Number(this.buyCoinsCount) || 0
            }
            this.$axios
                .post('/qrpayment', data)
                .then((res) => {
                    if (
                        res.data &&
                        (
                            res.data.code === 'WECHAT_NOT_AVAILABLE' ||
                            res.data.code === 'WECHAT_ORDER_FAIL' ||
                            res.data.code === 'WECHAT_ORDER_ERROR'
                        )
                    ) {
                        this.$message({
                            message: res.data.message || '微信支付暂时不可用，请选择支付宝',
                            type: 'warning'
                        })
                        if (subject === '购买金币') this.isBuyCoinsPayment = false
                        return
                    }
                    this.money = money
                    this.qrimg = res.data.filename
                    this.currentPayType = payType || 'alipay'
                    this.dialogTableVisible = true
                    this.paymentOrderNo = res.data.out_trade_no
                })
                .catch((err) => {
                    if (subject === '购买金币') this.isBuyCoinsPayment = false
                    const msg =
                        (err.response && err.response.data && err.response.data.message) ||
                        err.message ||
                        '支付请求失败，请稍后重试'
                    this.$message({ message: msg, type: 'warning' })
                })
        },
        confirmBuyCoins() {
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) {
                this.$message({ message: '请先登录后再购买金币', type: 'warning' })
                return
            }
            const n = Number(this.buyCoinsCount)
            if (isNaN(n) || n < 10) {
                this.$message({ message: '购买数量至少为 10', type: 'warning' })
                return
            }
            const money = parseFloat(this.buyPaymentAmount)
            if (isNaN(money) || money <= 0) {
                this.$message({ message: '应付金额无效', type: 'warning' })
                return
            }
            this.isBuyCoinsPayment = true
            const payType = this.buyCoinsPayType === 'alipay' ? 'alipay' : 'wepay'
            this.showBuyCoinsDialog = false
            this.doPayment(money, '购买金币', payType)
        },
        paystatus() {
            const wasBuyCoins = this.isBuyCoinsPayment
            const orderNo = this.paymentOrderNo
            const buyAmount = Number(this.buyCoinsCount) || 0
            this.dialogTableVisible = false
            this.$axios
                .post('/queryOrder', { out_trade_no: orderNo })
                .then(async (res) => {
                    const txt = res.data == null ? '' : (typeof res.data === 'string' ? String(res.data).trim() : '')
                    if (txt !== '交易完成') {
                        this.$message({
                            message: txt || '未检测到支付完成，若已付款请稍后刷新或联系客服',
                            type: 'warning'
                        })
                        return
                    }
                    if (!wasBuyCoins) return
                    const token = this.$store.state.user && this.$store.state.user.token
                    if (!token || buyAmount <= 0) {
                        this.$message({
                            message: '登录已失效或数量异常，请重新登录后再试或联系客服核对订单',
                            type: 'warning'
                        })
                        this.isBuyCoinsPayment = false
                        return
                    }
                    try {
                        const payload = { token, type: 'earn', amount: buyAmount, remark: '购买金币' }
                        if (orderNo) payload.out_trade_no = orderNo
                        const r = await this.$axios.post('/user/coin/log', payload)
                        if (r.data && r.data.coins != null) {
                            this.$store.commit('SetUserCoins', r.data.coins)
                        } else {
                            const cur = this.$store.state.user && this.$store.state.user.coins
                            this.$store.commit('SetUserCoins', (cur || 0) + buyAmount)
                        }
                        this.$message({ message: '购买成功', type: 'success' })
                    } catch (e) {
                        const msg =
                            (e.response && e.response.data && e.response.data.message) ||
                            e.message ||
                            '金币到账失败，请刷新页面或联系客服'
                        this.$message({ message: msg, type: 'warning' })
                        this.refreshUserCoinsFromServer()
                    } finally {
                        this.isBuyCoinsPayment = false
                    }
                })
                .catch((err) => {
                    this.$message({
                        message: (err.response && err.response.data) || err.message || '查询支付状态失败，请稍后重试',
                        type: 'warning'
                    })
                })
        },
        refreshUserCoinsFromServer() {
            const user = this.$store.state.user
            if (!user || !user.token) return
            this.$axios
                .get('/user/profile', { params: { token: user.token } })
                .then((res) => {
                    if (res.data && res.data.coins != null) this.$store.commit('SetUserCoins', res.data.coins)
                    if (res.data && res.data.hideFollowOfficialEarn != null) {
                        this.$store.commit('SetUserHideFollowOfficialEarn', !!res.data.hideFollowOfficialEarn)
                    }
                })
                .catch(() => {})
        }
    }
}
</script>

<style lang="less" scoped>
.buy-coins-dialog ::v-deep .el-dialog__header,
.earn-coin-dialog ::v-deep .el-dialog__header {
    padding: 18px 20px 14px;
    border-bottom: 1px solid #ebeef5;
}

.buy-coins-dialog-title,
.earn-coin-dialog-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
}

.buy-coins-dialog-title i,
.earn-coin-dialog-title i {
    margin-right: 8px;
    font-size: 22px;
}

.buy-coins-dialog-title i {
    color: #e6a23c;
}

.earn-coin-dialog-title i {
    color: #67c23a;
}

.buy-coins-body,
.earn-coin-body {
    padding: 20px 0 8px;
}

.buy-coins-field {
    margin-bottom: 20px;
}

.buy-coins-label,
.earn-coin-label {
    display: block;
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
}

.buy-coins-input {
    width: 100%;
}

.buy-coins-input ::v-deep .el-input-number {
    width: 100%;
}

.buy-coins-summary {
    background: #f5f7fa;
    border-radius: 8px;
    padding: 14px 16px;
    margin-bottom: 22px;
}

.buy-coins-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    margin-bottom: 8px;
}

.buy-coins-row:last-child {
    margin-bottom: 0;
}

.buy-coins-desc {
    color: #909399;
}

.buy-coins-price {
    color: #e6a23c;
    font-weight: 500;
}

.buy-coins-row.total .buy-coins-desc {
    font-weight: 500;
    color: #606266;
}

.buy-coins-amount {
    font-size: 18px;
    font-weight: 600;
    color: #f56c6c;
}

.buy-coins-footer,
.earn-coin-footer {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
}

.buy-coins-btn {
    flex: 1;
}

.earn-coin-tip {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #606266;
    line-height: 1.6;
}

.earn-coin-tip i {
    font-size: 18px;
    color: #67c23a;
    flex-shrink: 0;
    margin-top: 2px;
}

.earn-state-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 180px;
    color: #606266;
    font-size: 14px;
}

.earn-state-panel--error {
    color: #f56c6c;
}

.earn-coin-qr-wrap {
    margin: 0 auto 18px;
    width: 100%;
    max-width: 280px;
    padding: 12px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.earn-coin-qr {
    width: 100%;
    display: block;
    border-radius: 4px;
}

.legacy-earn-code-wrap {
    margin-bottom: 20px;
}

.legacy-earn-code-label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #606266;
}

.earn-status-box {
    padding: 14px 16px;
    border-radius: 10px;
    background: #f5f7fa;
    border: 1px solid #ebeef5;
    margin-bottom: 20px;
}

.earn-status-box--success {
    background: #f0f9eb;
    border-color: #d9f2c5;
}

.earn-status-box--error {
    background: #fef0f0;
    border-color: #fbc4c4;
}

.earn-status-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 6px;
}

.earn-status-desc {
    font-size: 13px;
    color: #606266;
    line-height: 1.6;
}

@media (max-width: 768px) {
    .buy-coins-dialog ::v-deep .el-dialog,
    .pay-qr-dialog ::v-deep .el-dialog,
    .earn-coin-dialog ::v-deep .el-dialog {
        max-width: calc(100vw - 24px) !important;
        margin: 12px auto !important;
    }

    .earn-coin-footer {
        flex-wrap: wrap;
    }

    .earn-coin-footer .el-button {
        flex: 1;
        min-width: 120px;
    }
}
</style>

<style lang="less">
.dark-mode {
    .buy-coins-dialog-title,
    .earn-coin-dialog-title {
        color: var(--text-primary);
    }

    .buy-coins-label,
    .earn-coin-label,
    .legacy-earn-code-label {
        color: var(--text-regular);
    }

    .buy-coins-summary,
    .earn-status-box {
        background: var(--bg-secondary);
        border-color: var(--border-color);
    }

    .buy-coins-desc,
    .earn-status-desc {
        color: var(--text-secondary) !important;
    }

    .buy-coins-row.total .buy-coins-desc,
    .earn-status-title {
        color: var(--text-regular) !important;
    }

    .earn-coin-tip {
        background: var(--tip-bg) !important;
        border-color: var(--tip-border) !important;
        color: var(--text-regular) !important;
    }

    .earn-coin-qr-wrap {
        background: var(--bg-card) !important;
        border-color: var(--border-color) !important;
        box-shadow: 0 2px 12px var(--shadow-color) !important;
    }

    .buy-coins-dialog .el-dialog__header,
    .earn-coin-dialog .el-dialog__header {
        border-bottom-color: var(--border-color);
    }
}
</style>
